<template>
	<div class="assign-board-wrap">
		<!-- 展开态: 完整看板(默认打开) -->
		<div v-if="!collapsed" class="assign-board">
			<div class="ab-head">
				<span class="ab-title"><i class="el-icon-data-board"></i> 分配看板</span>
				<span class="ab-btns">
					<i class="el-icon-refresh" title="刷新" @click.stop="load"></i>
					<i class="el-icon-arrow-up" title="收起" @click.stop="collapsed = true"></i>
			</span>
		</div>
		<div class="ab-body" v-loading="loading">
			<div class="ab-kpis">
				<div class="ab-kpi">
					<span class="ab-kpi-label">今日分配</span>
					<span class="ab-kpi-val ab-blue">{{ stats.todayAssigned || 0 }}</span>
				</div>
				<div class="ab-kpi">
					<span class="ab-kpi-label">今日成交</span>
					<span class="ab-kpi-val">{{ stats.todayFinished || 0 }}</span>
				</div>
				<div class="ab-kpi">
					<span class="ab-kpi-label">今日成交率</span>
					<span class="ab-kpi-val ab-green">{{ stats.todayDealRate || 0 }}%</span>
				</div>
			</div>
			<div class="ab-sub">全员今日接待情况</div>
			<div class="ab-list">
				<div v-if="!salesList.length" class="ab-empty">暂无业务员</div>
				<table v-else>
					<thead>
						<tr>
							<th>业务员</th>
							<th class="sortable" :class="{ active: sortKey === 'todayAssigned' }" @click="onSort('todayAssigned')">今日{{ sortArrow('todayAssigned') }}</th>
							<th class="sortable" :class="{ active: sortKey === 'todayFinished' }" @click="onSort('todayFinished')">成交{{ sortArrow('todayFinished') }}</th>
							<th class="sortable" :class="{ active: sortKey === 'todayDealRate' }" @click="onSort('todayDealRate')">成交率{{ sortArrow('todayDealRate') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="s in sortedSalesList" :key="s.salesId">
							<td class="ab-name">{{ s.salesName }}</td>
							<td class="ab-blue">{{ s.todayAssigned }}</td>
							<td>{{ s.todayFinished }}</td>
							<td class="ab-green">{{ s.todayDealRate }}%</td>
						</tr>
					</tbody>
				</table>
			</div>
			</div>
		</div>
		<!-- 收起态: 整个看板折叠成小按钮,不挡聊天视线,点击展开 -->
		<div v-else class="assign-board-mini" title="展开分配看板" @click="collapsed = false">
			<i class="el-icon-data-board"></i>
		</div>
	</div>
</template>

<script>
import bizApi from "../../api/bizApi.js";

export default {
	name: "chatAssignBoard",
	props: {
		// 群订单上下文(需含 bound/merchantId/isFinance)
		orderCtx: { type: Object, default: null }
	},
	data() {
		return {
			loading: false,
			collapsed: false,
			stats: {},
			salesList: [],
			// 排序: 点表头第一下从高到低,再点从低到高,点其他列重置为从高到低
			sortKey: '',
			sortDir: 'desc'
		};
	},
	computed: {
		sortedSalesList() {
			if (!this.sortKey) {
				return this.salesList;
			}
			const key = this.sortKey, dir = this.sortDir === 'asc' ? 1 : -1;
			return [...this.salesList].sort((a, b) => {
				const va = key === 'todayDealRate' ? parseFloat(a.todayDealRate) || 0 : (a[key] || 0);
				const vb = key === 'todayDealRate' ? parseFloat(b.todayDealRate) || 0 : (b[key] || 0);
				return (va - vb) * dir;
			});
		}
	},
	watch: {
		orderCtx: {
			immediate: true,
			handler(ctx) {
				if (ctx && ctx.bound && ctx.merchantId) {
					this.load();
				}
			}
		}
	},
	methods: {
		load() {
			const merchantId = this.orderCtx && this.orderCtx.merchantId;
			if (!merchantId) {
				return;
			}
			// 同群多商户(商户4+商户6同绑上粉群): 传全部绑定商户聚合,避免只统计首个商户看板没数据
			const ids = this.orderCtx.merchantIds && this.orderCtx.merchantIds.length > 1
				? this.orderCtx.merchantIds.join(',') : null;
			this.loading = true;
			bizApi.assignStats(merchantId, ids).then((d) => {
				this.stats = d || {};
				this.salesList = (d && d.salesList) || [];
			}).catch(() => { }).finally(() => {
				this.loading = false;
			});
		},
		onSort(key) {
			if (this.sortKey === key) {
				// 同一列: 高→低 / 低→高 交替
				this.sortDir = this.sortDir === 'desc' ? 'asc' : 'desc';
			} else {
				this.sortKey = key;
				this.sortDir = 'desc';
			}
		},
		sortArrow(key) {
			if (this.sortKey !== key) {
				return '';
			}
			return this.sortDir === 'desc' ? ' ↓' : ' ↑';
		}
	}
};
</script>

<style lang="scss" scoped>
// 收起态小按钮: 折叠后的看板入口,贴聊天区右上角,点击展开
.assign-board-mini {
	position: absolute;
	top: 8px;
	right: 10px;
	z-index: 20;
	width: 30px;
	height: 30px;
	border-radius: 8px;
	background: linear-gradient(135deg, #409eff, #337ecc);
	color: #fff;
	font-size: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
	user-select: none;

	&:hover {
		opacity: .92;
	}
}

.assign-board {
	// 贴聊天区右上角(父级 .content-box 已 position:relative)
	position: absolute;
	top: 8px;
	right: 10px;
	z-index: 20;
	width: 260px;
	background: #fff;
	border: 1px solid #e4e7ed;
	border-radius: 10px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);
	overflow: hidden;

	.ab-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 7px 10px;
		background: linear-gradient(135deg, #409eff, #337ecc);
		color: #fff;
		user-select: none;

		.ab-title {
			font-size: 13px;
			font-weight: 600;

			i {
				margin-right: 4px;
			}
		}

		.ab-btns i {
			margin-left: 8px;
			cursor: pointer;
			opacity: .9;

			&:hover {
				opacity: 1;
			}
		}
	}

	.ab-body {
		padding: 8px 10px;
	}

	.ab-kpis {
		display: flex;
		justify-content: space-between;

		.ab-kpi {
			display: flex;
			flex-direction: column;
			align-items: center;
			flex: 1;
		}

		.ab-kpi-label {
			font-size: 11px;
			color: #909399;
		}

		.ab-kpi-val {
			font-size: 18px;
			font-weight: 700;
			color: #303133;
		}
	}

	.ab-sub {
		margin: 8px 0 4px;
		font-size: 11px;
		color: #909399;
		border-top: 1px dashed #f0f2f5;
		padding-top: 6px;
	}

	.ab-list {
		// 高度自适应: 屏幕够高全部展示,不够时内部滚动(预留头部+总览+输入区高度)
		max-height: calc(100vh - 430px);
		overflow-y: auto;

		table {
			width: 100%;
			border-collapse: collapse;
			font-size: 12px;
		}

		th {
			text-align: left;
			color: #909399;
			font-weight: normal;
			padding: 3px 4px;
			border-bottom: 1px solid #f0f2f5;
			white-space: nowrap;

			&.sortable {
				cursor: pointer;
				user-select: none;

				&:hover,
				&.active {
					color: #409eff;
				}
			}
		}

		td {
			padding: 4px;
			border-bottom: 1px dashed #f5f6f8;
		}

		.ab-name {
			max-width: 76px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.ab-empty {
		color: #c0c4cc;
		text-align: center;
		padding: 10px 0;
		font-size: 12px;
	}

	.ab-blue {
		color: #409eff;
	}

	.ab-green {
		color: #07c160;
	}
}
</style>
